import { isNil, isString } from 'lodash'
import { isValidIBAN as _isValidIBAN, electronicFormatIBAN } from 'ibantools'

export const ibanRegex =
    /^(?:(?:IT|SM)\w{2}[A-Z]\w{22}|CY\w{2}[A-Z]\w{23}|NL\w{2}[A-Z]{4}\w{10}|LV\w{2}[A-Z]{4}\w{13}|(?:BG|BH|GB|IE)\w{2}[A-Z]{4}\w{14}|GI\w{2}[A-Z]{4}\w{15}|RO\w{2}[A-Z]{4}\w{16}|KW\w{2}[A-Z]{4}\w{22}|MT\w{2}[A-Z]{4}\w{23}|NO\w{13}|(?:DK|FI|GL|FO)\w{16}|MK\w{17}|(?:AT|EE|KZ|LU|XK|LT)\w{18}|(?:BA|HR|LI|CH|CR)\w{19}|(?:GE|DE|ME|RS)\w{20}|IL\w{21}|(?:AD|CZ|ES|MD|SA)\w{22}|PT\w{23}|(?:BE)\w{14}|(?:FR|MR|MC)\w{25}|(?:AL|DO|LB|PL)\w{26}|(?:AZ|HU)\w{27}|(?:GR|MU)\w{28})$/gim

export const emailRegex = /^\S+@\S+\.\S+$/

const dateRegex = new RegExp('^(0[1-9]|[12][0-9]|3[01])[/](0[1-9]|1[012])[/](19|20)[0-9]{2}$')

export const isEmailValid = (email: string): boolean => {
    return !isNil(email.match(emailRegex))
}

export const isValidIBAN = (IBAN: string | undefined): boolean => {
    const formattedIBAN = electronicFormatIBAN(IBAN)
    return isString(formattedIBAN) && _isValidIBAN(formattedIBAN)
}

export const isValidDate = (date: string): boolean => {
    return dateRegex.test(date)
}

const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[4][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i
export const isValidUUID = (uuid: unknown): boolean => {
    return isString(uuid) && uuidRegex.test(uuid)
}

const mongoIdRegex = /^[0-9a-f]{24}$/i
export const isValidMongoDBObjectId = (id: unknown): boolean => {
    return isString(id) && mongoIdRegex.test(id)
}
